import Cookies from "universal-cookie";
const cookies = new Cookies();

export default {
    isMobile: (): boolean => {
        if (window.innerWidth <= 900) {
            return true;
        }

        return false;
    },

    isIntroductionCookieAvailable: (): boolean => {
        if (cookies.get("introduction")) {
            return true;
        }
        return false;
    },

    setIntroductionCookie: (): void => {
        cookies.set("introduction", {
            path: "/",
            maxAge: 60 * 60,
        });
    },
};
